module.exports = __webpack_public_path__ + "static/media/icon2.8c3b0b0b.svg";